import { BaseRouteState, RoutingConfig } from '../lib/routing/types';

const defaultRouteState: BaseRouteState = {
    page: null,
    industries: [],
    services: [],
    solutions: [],
    technologies: [],
};

const enabledRefinementLists = ['industries', 'services', 'solutions', 'technologies'];

const basePath = 'case-studies';

export const caseStudiesRoutingConfig: Omit<RoutingConfig<typeof basePath>, 'index'> = {
    defaultRouteState,
    enabledRefinementLists,
    basePath,
};
